<form class="usuario-form-content" (ngSubmit)="submit()">
  <div class="form-heading">
    <div>
      <span class="eyebrow">Administración de usuarios</span>
      <h2>{{ usuario ? 'Editar usuario' : 'Nuevo usuario' }}</h2>
    </div>
    <button class="close-button" type="button" (click)="cancelled.emit()" aria-label="Cerrar">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <p class="form-description">Define los datos de acceso, la empresa y los roles del usuario.</p>

  <div class="form-grid">
    <label>
      Nombre completo
      <input name="nombre" [(ngModel)]="form.nombre" placeholder="Ej. María Pérez" />
    </label>
    @if (!usuario) {
      <label>
        Usuario
        <input name="usuario" [(ngModel)]="form.usuario" placeholder="Ej. mperez" />
      </label>
      <label>
        Contraseña {{ usuario ? '(opcional)' : '' }}
        <input
          name="password"
          type="password"
          [(ngModel)]="form.password"
          [placeholder]="usuario ? 'Déjala vacía para conservarla' : 'Ingresa una contraseña'"
        />
      </label>
    }
    <label for="empresas">
      Empresa <small>(opcional)</small>
      <app-select
        name="empresaId"
        [(ngModel)]="form.empresaId"
        [options]="empresaOptions"
        placeholder="Sin empresa"
        aria-label="Empresa"
      />
    </label>
    <fieldset class="roles-field full-width">
      <legend>Roles</legend>
      <div class="roles-list">
        @for (rol of roles; track rol.id) {
          <label class="role-option">
            <input
              type="checkbox"
              [value]="rol.id"
              [checked]="form.rolIds.includes(rol.id)"
              (change)="onRoleChange(rol.id, $event)"
            />
            <span>{{ rol.nombre }}</span>
          </label>
        }
      </div>
    </fieldset>
  </div>

  @if (error || serverError) {
    <div class="form-error">
      <i class="fa-solid fa-circle-exclamation"></i>{{ error || serverError }}
    </div>
  }

  <footer class="form-actions">
    <button class="secondary-button" type="button" (click)="cancelled.emit()">Cancelar</button>
    <button class="primary-button" type="submit">
      <i class="fa-solid fa-check"></i>{{ usuario ? 'Guardar cambios' : 'Crear usuario' }}
    </button>
  </footer>
</form>
